<template>
  <gj-modal :visible.sync="modalVisible" global :size="item.type === 'SHOP_AUTH_EXPIRES' || item.type === 'NO_DOCKING_SHOP'?'auto':'700x450'" v-bind="$attrs"
            v-on="$listeners">
    <template #header>
      <span v-if="item.type === 'SHOP_AUTH_EXPIRES' || item.type === 'NO_DOCKING_SHOP'"
      >店铺授权</span>
<!--      <span v-else-if="item.type === 'ORDER_USER_UP' || item.type === 'TOP_UP_WARNING'">余额提醒</span>-->
    </template>
    <template #content>

      <!-- 店铺授权 -->
      <template v-if="item.type === 'SHOP_AUTH_EXPIRES' || item.type === 'NO_DOCKING_SHOP'">
        <div class="padd-20-40">
          <div class="flex-center text">授权店铺获得软件顾问专属服务</div>
          <div class="flex margin-50-0">
            <div class="flex-column padd-l-r-40" v-for="item in serviceList" :key="item.index">
              <img class="icon-80 m-b-10" :src="item.img" alt />
              <gj-text class="son-text">{{item.textOne}}</gj-text>
              <gj-text class="son-text">{{item.textTwo}}</gj-text>
            </div>
          </div>
          <div class="flex-center">
            <gj-button class="btn-blue" type="primary" @click="openAuth">立即授权</gj-button>
            <gj-button class="btn-white" @click="openRecharge">购买套餐</gj-button>
          </div>
          <div class="flex-center m-t-30 text-foot">
            如有疑问，可联系
            <span id="msg_auth_kefu" class="text-a-foot m-l-10">在线客服</span>
          </div>
        </div>
      </template>

      <!-- 余额提醒 -->
      <template v-else-if="item.type === 'ORDER_USER_UP' || item.type === 'ORDER_RUNNING_LOW' || item.type === 'ACCOUNT_DEACTIVATION' || item.type === 'EMAIL_UP_WARNING'">
        <div class="flex warning-box">

          <gj-button class="close-btn" type="text" @click="cancel">
            <i class="el-icon-close"></i>
          </gj-button>

          <div class="flex warning-img-box blue-bg">
            <img v-if="item.type === 'ACCOUNT_DEACTIVATION'" :src="warnImgs[1]"/>
            <img v-else :src="warnImgs[0]"/>
          </div>

          <div class="flex warning-info-box" v-if="item.type === 'ORDER_RUNNING_LOW'">
            <div class="warning-info-box-tit">订单量预计可用</div>
            <div class="warning-info-day-box flex" >
              <div class="warning-info-box-day">{{item.content?item.content.bizId:'-'}}</div>
              <div class="warning-info-box-tip">请尽快去购买套餐，订单余额使用完15天后将无法正常使用系统！</div>
            </div>
            <div>
              <gj-button class="warning-info-btn blue-btn" type="primary" @click="openRecharge">去购买套餐</gj-button>
            </div>
          </div>

          <div class="flex warning-info-box" v-if="item.type === 'ORDER_USER_UP'">
            <div class="warning-info-box-tit">订单量余额已用完</div>
            <div class="warning-info-box-str">
              您的<span class="color-str">订单量余额已使用完</span>，为了正常使用系统，请尽快去购买套餐，{{item.content.bizId[0]}}年{{item.content.bizId[1]}}月{{item.content.bizId[2]}}日将<span class="color-str">无法正常使用系统功能！</span>
            </div>
            <div>
              <gj-button class="warning-info-btn blue-btn" type="primary" @click="openRecharge">去购买套餐</gj-button>
            </div>
          </div>

          <div class="flex warning-info-box" v-if="item.type === 'ACCOUNT_DEACTIVATION'">
            <div class="warning-info-box-tit">账户已被停用</div>
            <div class="warning-info-box-str">
              由于<span class="color-str">订单量余额不足</span>，账户已经被停用，购买套餐后，订单包<span class="color-str">余额大于0</span>，会立即恢复账户使用。
            </div>
            <div>
              <gj-button class="warning-info-btn red-btn" type="primary" @click="openRecharge">去购买套餐</gj-button>
            </div>
          </div>

         <!-- 邮件剩余不足 -->
         <div class="flex warning-info-box" v-if="item.type === 'EMAIL_UP_WARNING'">
            <div class="warning-info-box-tit">{{item.content?item.content.content:'-'}}</div>
            <div>
              <gj-button class="warning-info-btn blue-btn" type="primary" @click="openRecharge">去购买></gj-button>
            </div>
          </div>
        </div>
      </template>

<!--      <template v-else-if="item.type === 'ORDER_USER_UP' || item.type === 'TOP_UP_WARNING'">-->
<!--        <div class="flex p-tb-rl">-->
<!--          <div class="img-tap"></div>-->
<!--          <div class="flex-center2">-->
<!--            <div class="flex-column">-->
<!--              <gj-text class="col-333" v-if="item.type === 'ORDER_USER_UP'">-->
<!--                您的余额为<gj-text class="text-recharge">{{balance}}</gj-text>单，-->
<!--              </gj-text>-->
<!--              <gj-text v-else class="text-recharge">您的余额已不足，</gj-text>-->
<!--              <gj-text class="col-333">请立即去办理充值！</gj-text>-->
<!--            </div>-->
<!--            <div>-->
<!--              <gj-button class="btn-recharge m-t-30" type="primary" @click="openRecharge">立即充值</gj-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
    </template>
  </gj-modal>
</template>
<script>
  import {kefuMixin, modalMixIn} from "../../../../../minxins";
import { batchMarkAccountMessage } from "../../../../../api/message";

export default {
  name: "app-warning-modal",
  mixins: [modalMixIn, kefuMixin],
  props: {
    item: null
  },
  data() {
    return {
      kefuLink: 'https://wp.qiye.qq.com/qidian/3009000551/76364fe91f88615adaaf8aaa9ad765dc',
      serviceList: [
        {
          img: require("./img/img-serviceOne.png"),
          textOne: "亚马逊第三方",
          textTwo: "安全服务商"
        },
        {
          img: require("./img/img-serviceTwo.png"),
          textOne: "一站式亚马逊",
          textTwo: "业务管理服务"
        },
        {
          img: require("./img/img-serviceThree.png"),
          textOne: "支持多店铺和",
          textTwo: "多站点授权"
        },
        {
          img: require("./img/img-serviceFour.png"),
          textOne: "授权后",
          textTwo: "无关联风险"
        }
      ],
      warnImgs:[
        require("./img/warning-img01.png"),
        require("./img/warning-img02.png")
      ]
    };
  },
  computed: {
     balance() {
       if (this.item.type === 'ORDER_USER_UP') {
         return 0;
       } 
       return null;
    }

  },
  methods: {
    openAuth() {
      if (this.item.type === "SHOP_AUTH_EXPIRES") {
        this.batchMark();
      }
      if (this.$route.path !== "/system/market") {
        this.$router.push({ path: "/system/market" });
      }
      this.cancel();
    },
    openRecharge() {
      this.batchMark();
      if (this.$route.path !== "/setting/erp-package") {
        this.$router.push({ path: "/setting/erp-package" });
      }
      this.cancel();
    },
    batchMark() {
      batchMarkAccountMessage(this.item.centerIds === null || this.item.centerIds === 'null' ? '' : this.item.centerIds);
    }
  }
};
</script>

<style scoped lang="scss">

.warning-box{
  position: relative;
  height: 100%;
  width: 100%;

  .close-btn{
    position: absolute;
    right:15px;
    top:15px;
    padding: 0;
    .el-icon-close{
      font-size: 16px;
      color: #999;
    }
    .el-icon-close:hover{
      color: #1F6EEF;
    }
  }


  .warning-img-box{
    flex: 1;
    align-items: center;
    justify-content: center;
  }
  .blue-bg{
    background-image: linear-gradient(154deg, #FEFEFE 0%, #F5FBFF 91%);
  }
  .red-bg{
    background-image: linear-gradient(154deg, #FFFCFB 0%, #FFF9F9 91%);
  }
  .warning-info-box{
    flex: 1;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    padding: 100px 0 90px;
    .warning-info-box-tit{
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      color: #333333;
      font-weight: 600;
    }
    .warning-info-box-str{
      font-family: PingFangSC-Regular;
      padding: 0 55px;
      line-height: 22px;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      text-align: justify;
      letter-spacing: .4px;
      .color-str{
        color: #ED6A0C;
      }
    }

    .warning-info-day-box{
      flex: 1;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .warning-info-box-day{
        font-family: PingFangSC-Semibold;
        font-size: 80px;
        color: #F23D2D;
        font-weight: 600;
        padding: 13px 0;
        position: relative;
      }
      .warning-info-box-day:after{
        content: '天';
        font-family: PingFangSC-Semibold;
        font-size: 25px;
        color: #333333;
        font-weight: 600;
        position: absolute;
        bottom: 40px;
      }
      .warning-info-box-tip{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        text-align: center;
        font-weight: 400;
        padding: 0 40px;
      }
    }

    .warning-info-btn{
      width: 168px;
      height: 32px;
      line-height: 32px;
      padding: 0;
      border: 0;
      border-radius: 2px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      font-weight: 600;
    }
    .blue-btn{
      background-image: linear-gradient(90deg, #42A7F8 0%, #1F6EEF 100%);
    }
    .red-btn{
      background-image: linear-gradient(90deg, #FF5432 0%, #FCA889 100%);
    }
  }
}

.img-tap {
  width: 256px;
  height: 214px;
  margin-right: 60px;
  background-image: url("./img/img-balance.png");
}
.close {
  cursor: pointer;
  position: absolute;
  right: 4px;
  top: -4px;
}
.padd-l-r-40 {
  padding: 0px 50px 0px 40px;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.icon-80 {
  height: 80px;
  width: 80px;
}
.padd-20-40 {
  padding: 20px 40px;
}
.flex-center {
  display: flex;
  justify-content: center;
}
.flex-center2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.margin-50-0 {
  margin: 50px 0px;
}
.m-t-30 {
  margin-top: 30px;
}
.m-r-60 {
  padding-right: 60px;
}
.m-l-10 {
  margin-left: 10px;
}
.text {
  font-size: 23px;
  line-height: 30px;
  color: #000000;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
.son-text {
  font-family: Microsoft YaHei;
  font-size: 12px;
  color: #000000;
  font-weight: bold;
  text-align: center;
}
.m-b-10 {
  margin-bottom: 10px;
}
.btn-blue {
  width: 148px;
  height: 42px;
  background: #1F6EEF;
  opacity: 1;
  border-radius: 6px;
  margin-right: 10px;
}
.btn-white {
  width: 148px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #1F6EEF;
  opacity: 1;
  border-radius: 6px;
  color: #1F6EEF;
  margin-left: 10px;
}
.text-foot {
  height: 16px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 16px;
  color: #707070;
  opacity: 1;
}
.text-a-foot {
  height: 16px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 16px;
  color: #1F6EEF;
  opacity: 1;
  text-decoration: none;
  cursor: pointer;
}
.btn-recharge {
  width: 166px;
  height: 42px;
  background: #1F6EEF;
  opacity: 1;
  border-radius: 6px;
}
.p-tb-rl {
  padding: 50px 40px;
}
.text-recharge {
  font-weight: bold;
  font-size: 23px;
  font-family: Microsoft YaHei;
  color: #ff0303;
  opacity: 1;
  line-height: 40px;
}
.col-333 {
  color: #333333;
}
</style>
